<template>
	<div>
		<div class="border p-5 mb-5">
			<b-row>
				<b-col cols="12" class="mb-4">
					<h6>Fakülte</h6>
					<faculty-selectbox v-model="faculty_code"/>
					<span>{{ faculty_code }}</span>
				</b-col>
			</b-row>
		</div>
		<div class="border p-5">
			<b-row>
				<b-col md="12" class="mb-4">
					<h6>Null</h6>
					<department-selectbox-multiple v-model="value1" :faculty_code="faculty_code"/>
					<span>{{ value1 }}</span>
				</b-col>
				<b-col md="12" class="mb-4">
					<h6>Validate Error</h6>
					<department-selectbox-multiple v-model="value2" :faculty_code="faculty_code" :validateError="value2ValidateError"/>
					<span>{{ value2 }}</span>
				</b-col>
				<b-col cols="12">
					<b-button @click="change()" variant="primary">Değiştir</b-button>
				</b-col>
			</b-row>
		</div>
	</div>
</template>
<script>
	import FacultySelectbox from "@/components/interactive-fields/FacultySelectbox";
	import DepartmentSelectboxMultiple from "@/components/interactive-fields/DepartmentSelectboxMultiple";

	export default {
		components: {
			FacultySelectbox,
			DepartmentSelectboxMultiple,
		},
		data() {
			return {
				faculty_code: '04',

				value1: null,
				value2: '0401,0408',
				value2ValidateError: 'Validate Error is Working',
			}
		},
		methods: {
			change() {
				this.faculty_code = '01'

				this.value2 = '0102,0103'
				this.value2ValidateError = 'Error'
			}
		}
	};
</script>

